import React from 'react';
export const AssignmentsContext = React.createContext(null);
export const AssignmentContext = React.createContext(null);
export const AssignmentsNavigationContext = React.createContext(null);
export const AssignmentDocumentsContext = React.createContext(null);